import FooterLegalLinks from './FooterLegalLinks';

export default FooterLegalLinks;
